import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatosUsuariosService } from '../../services/datos-usuarios.service';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';

@Component({
  selector: 'app-usuarios-filter-details',
  templateUrl: './usuarios-filter-details.component.html',
  styleUrls: ['./usuarios-filter-details.component.css']
})
export class UsuariosFilterDetailsComponent implements OnInit {

  usuarioEstados: DesplegableData[] = [];
  @Output() estadoSeleccionado: EventEmitter<string> = new EventEmitter<string>();

  constructor(private datosUsuariosService: DatosUsuariosService,
              private _snackBar: MatSnackBar,
              private conversionDatosApiService: ConversionDatosApiService) { }

  ngOnInit(): void {
    this.getEstadosUsuario();
  }

  getEstadosUsuario(){
    this.datosUsuariosService.getEstadosUsuario().subscribe(
      next => {
        this.usuarioEstados = this.conversionDatosApiService.mapCodigoAIdEntrada(next);
        this.preseleccionarTodos();
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  filterEstado(event: DesplegableData | null){
    if (!event) return;
    this.estadoSeleccionado.emit(event.desc)
  }

  private preseleccionarTodos(): void {
    if (!this.usuarioEstados.length) return;

    const estadoTodos = this.usuarioEstados.find((estado) =>
      estado.desc?.toUpperCase() === 'TODOS' ||
      estado.desc?.toUpperCase() === 'TODOS LOS ESTADOS' ||
      estado.id?.toUpperCase() === 'TODOS'
    ) || this.usuarioEstados[0];

    this.usuarioEstados = this.usuarioEstados.map((estado) => ({
      ...estado,
      seleccionado: estado.id === estadoTodos.id
    }));

    this.estadoSeleccionado.emit(estadoTodos.desc);
  }

}
